var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.noDestinationsError)?_c('router-view'):_c('v-alert',{attrs:{"value":_vm.noDestinationsError,"color":"error","icon":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('arrivals_departures.no_destinations_found', 'No destinations found. Please contact an admin to add destinations for your organization.'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }